import React, { useState } from 'react';
import { Content } from 'rsuite';

import NavigationBar from '../Shared/NavigationBar';
import SetSearchBar from './SetSearchBar';
import SetSymbolGrid from './SetSymbolGrid';
import { API_BASE } from '../../helpers/authFetch';

/**
 * Renders the Set search select box
 * @returns React Component
 */
const SetSearch = () => {
  const [term, setTerm] = useState('');
  const search = async (searchTerm) => {
    const results =  await fetch(`${API_BASE}/sets/search/${encodeURIComponent(searchTerm)}`);
    const data = await results.text();
    return data;
  };

   const goToSet = (set) => {
    if (set && set.id) {
      window.location.assign(`/set/${set.id}`);
    }
  };

  const wrapperStyles = {
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto'
  }

   return (
    <>
      <NavigationBar />
      <Content style={{ marginTop: "15px" }}>
        <div style={wrapperStyles}>
          <SetSearchBar term={term} retrieve={search} setTerm={setTerm} onSelect={goToSet} placeholder={'Enter a Set Name or Code'} />
          <SetSymbolGrid onSetClick={goToSet} />
        </div>
      </Content>
    </>
  );
}

export default SetSearch;
